// redux imports
import { MAX_LIST_SIZE } from 'constants/General'
import store from 'store'
import CONTACTS from 'constants/Contacts'

const coma = ','

let search = ''

/**
 * Checks in order
 * 1. name
 * 2. extension
 * 3. phone
 * 4. phones
 * @param contact
 * @returns {boolean}
 */
const contactContainsSearch = (contact) => {
  return (
    contact?.name?.toLowerCase()?.includes(search) ||
    contact?.extension?.toLowerCase()?.includes(search) ||
    contact?.phone?.toLowerCase()?.includes(search) ||
    (!search.includes(coma) && contact?.phones?.join(coma)?.includes(search))
  )
}

const contactMatchesText = (contact, text) => {
  return (
    contact?.name?.toLowerCase() === text ||
    contact?.extension?.toLowerCase() === text ||
    contact?.phone?.toLowerCase() === text ||
    contact?.phones?.some((phone) => phone === text)
  )
}

const contactMatchesExact = (contact) => {
  return contactMatchesText(contact, search)
}

export const filterContacts = (rawSearch, returnContact = false) => {
  search = String(rawSearch).toLowerCase().trim()
  const { contacts } = store.getState().contacts

  const contactList = []
  const extensionMatches = []
  const otherMatches = []

  // TODO flatten since contact includes type
  if (search) {
    CONTACTS.list.every((type) => {
      contacts[type].filter(Boolean).every((contact) => {
        if (contactContainsSearch(contact)) {
          // Prioritize extension matches over other field matches
          const isExtensionMatch = contact?.extension
            ?.toLowerCase()
            ?.includes(search)

          if (isExtensionMatch) {
            extensionMatches.push(contact.id)
            if (returnContact) {
              contactList.push(contact)
            }
          } else {
            otherMatches.push(contact.id)
            if (returnContact) {
              contactList.push(contact)
            }
          }
        }

        return extensionMatches.length + otherMatches.length < MAX_LIST_SIZE
      })

      return extensionMatches.length + otherMatches.length < MAX_LIST_SIZE
    })
  }

  const filteredIds = [...extensionMatches, ...otherMatches]

  if (returnContact) {
    return (
      contactList.find((contact) => contactMatchesExact(contact)) ||
      contactList[0]
    )
  }

  return filteredIds
}

export const findContact = (rawSearch) => {
  const searchText = String(rawSearch).toLowerCase().trim()
  const { contacts } = store.getState().contacts

  if (!searchText) {
    return null
  }

  let extensionMatch = null
  let otherMatch = null

  for (let i = 0; i < CONTACTS.list.length; i += 1) {
    const contact = contacts[CONTACTS.list[i]].find((cont) =>
      contactMatchesText(cont, searchText),
    )

    if (contact) {
      const isExtensionMatch = contact?.extension?.toLowerCase() === searchText

      if (isExtensionMatch && !extensionMatch) {
        extensionMatch = contact
      } else if (!isExtensionMatch && !otherMatch) {
        otherMatch = contact
      }

      if (extensionMatch) {
        return extensionMatch
      }
    }
  }

  return otherMatch
}
